export default __webpack_public_path__ + "static/media/1-2.611e9b8b.jpg";